import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as R from 'ramda';
import { PictureInitialParentType } from '~/apollo/generated/v4/graphql';
import { Heading } from '~/components/common/Heading';
import { SOPictureManager } from '~/components/upload/supporting-object/so-picture-manager';
import { useShowUnpublished } from '~/components/upload/supporting-object/use-show-unpublished';
import { useUpdatePaleoMapOutletContext } from '~/routes/upload/paleomap/$paleoMapId';
import {
  countUnpublishedItems,
  filterUnpublishedItems,
} from '~/utils/modules/supporting-object';

export default function UpdatePaleoMapPicturesRoute() {
  const { paleoMap, refetchQueries } = useUpdatePaleoMapOutletContext();

  const unpublishedCount = countUnpublishedItems(paleoMap.pictures);

  const { showUnpublished, PublishedToggle } =
    useShowUnpublished(unpublishedCount);

  const pictures = R.pipe(
    () => paleoMap.pictures,
    pics => (showUnpublished ? pics : filterUnpublishedItems(pics)),
    R.sortBy(picture => picture.priority ?? Infinity),
  )();

  return (
    <div className="space-y-4">
      <PublishedToggle />

      {paleoMap.pictures.length > 3 && (
        <div className="alert alert-warning">
          <FontAwesomeIcon icon={faExclamationTriangle} className="text-xl" />
          <div>
            <Heading level={3}>Maximum number of images exceeded</Heading>
            Only the first three images per paleomap will be shown to users.
          </div>
        </div>
      )}

      <SOPictureManager
        parentType={PictureInitialParentType.PaleoMap}
        parentId={parseInt(paleoMap.id)}
        pictures={pictures}
        refetchQueries={refetchQueries}
      />
    </div>
  );
}
